(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cards-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('mouseover', function (e) {
    const wrapper = e.target.closest('.c-card__media-wrapper');
    if (!wrapper) return;

    const video = wrapper.querySelector('.c-card__video');
    if (video) video.play();
  });

  document.addEventListener('mouseout', function (e) {
    const wrapper = e.target.closest('.c-card__media-wrapper');
    if (!wrapper) return;

    const video = wrapper.querySelector('.c-card__video');
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const isMobile = window.matchMedia('(max-width: 768px)').matches;

    // Hide navigation on mobile
    if (isMobile) {
      var nav = document.querySelector('.c-swiper-image__nav');
      if (nav) nav.style.display = 'none';
    }

    new Swiper('.image-carousel__swiper', {
      slidesPerView: 'auto',
      spaceBetween: 16,
      navigation: isMobile
        ? false
        : {
            nextEl: '.custom-button-next-image',
            prevEl: '.custom-button-prev-image',
          },
      freeMode: isMobile,
    });

    if (!isMobile) {
      document.querySelectorAll('.image-carousel .custom-button').forEach(function (button) {
        button.addEventListener('mousedown', function (event) {
          event.preventDefault();
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  const swiper = new Swiper('.product-carousel .swiper', {
    slidesPerView: 1.2,
    spaceBetween: 5,
    navigation: {
      nextEl: '.custom-button-next',
      prevEl: '.custom-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content-seperator"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const mainSection = document.querySelector('.shopify-section[id*="__main"]');
    if (!mainSection) return console.warn('No __main section found.');

    const separatorSection = Array.from(mainSection.parentElement.children).find(
      (el) => el.classList.contains('shopify-section') && /^shopify-section-.*__product_content_seperator_/.test(el.id)
    );
    if (!separatorSection) return console.warn('No separator section found.');

    const contentContainer = mainSection.querySelector('.c-product-under-gallery-sections');
    if (!contentContainer) return console.warn('Could not find .c-product-main__content in __main.');

    // Loop through siblings between mainSection and separatorSection
    let current = mainSection.nextElementSibling;
    while (current && current !== separatorSection) {
      const next = current.nextElementSibling; // Store next because current will be moved
      if (current.classList.contains('shopify-section')) {
        contentContainer.appendChild(current);
      }
      current = next;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.c-product-accordions .accordion-button').forEach((button) => {
      const content = button.nextElementSibling;
      // If aria-expanded true, show content
      if (button.getAttribute('aria-expanded') === 'true') {
        content.hidden = false;
      }
      button.addEventListener('click', () => {
        const isOpen = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', !isOpen);
        content.hidden = isOpen;
      });
    });

    // Learn more link scrolls to description accordion on mobile
    var learnMoreLink = document.querySelector('.c-product-learn-more-link');
    if (learnMoreLink) {
      learnMoreLink.addEventListener('click', function (e) {
        e.preventDefault();
        var descAccordion = document.getElementById('description-accordion');
        if (descAccordion) {
          var header = document.querySelector('header');
          var headerHeight = header ? header.offsetHeight : 80;
          var rect = descAccordion.getBoundingClientRect();
          var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          var targetY = rect.top + scrollTop - headerHeight - 30;
          window.scrollTo({ top: targetY > 0 ? targetY : 0, behavior: 'smooth' });
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
